import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { VatReleaseReasonQuery, VatReleaseReasonQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(VatReleaseReasonQuery)
@Wrapper(VatReleaseReasonQueryHandlerBase)
export class VatReleaseReasonQueryHandler {
    public constructor(
        http: Http,
    ) { }
}
